import { render, staticRenderFns } from "./ElasticChatStartup.vue?vue&type=template&id=4bd51ae5&scoped=true&"
import script from "./ElasticChatStartup.vue?vue&type=script&setup=true&lang=js&"
export * from "./ElasticChatStartup.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd51ae5",
  null
  
)

export default component.exports